/**
 * Lesson overlay canvas: drawing surface positioned over the lesson panel.
 * Receives refs and handlers from useWhiteboard (lesson surface only).
 * pointer-events: auto when active so drawing works; none when inactive so lesson stays clickable.
 */

import React from 'react';
import { SURFACES } from './constants';
import RemoteCursor from './RemoteCursor';
import './LessonOverlayCanvas.css';

function LessonOverlayCanvas({
  lessonCanvasRef,
  lessonContainerRef,
  getPointerHandlers,
  isActive,
  tool = 'pen',
  remoteCursor = null,
}) {
  const pointerHandlers = getPointerHandlers ? getPointerHandlers(SURFACES.LESSON) : {};
  const lessonCursor = remoteCursor?.lesson ?? null;

  return (
    <div
      className="lesson-overlay-canvas"
      style={{
        pointerEvents: isActive ? 'auto' : 'none',
        cursor: isActive && tool === 'pen'
          ? 'url(/cursors/pen.svg) 4 20, crosshair'
          : isActive && tool === 'eraser'
            ? 'url(/cursors/eraser.svg) 12 12, cell'
            : undefined,
      }}
    >
      <canvas
        ref={lessonCanvasRef}
        className="lesson-overlay-canvas-element"
        onContextMenu={(e) => e.preventDefault()}
        {...pointerHandlers}
      />
      <RemoteCursor containerRef={lessonContainerRef} cursor={lessonCursor} />
    </div>
  );
}

export default React.memo(LessonOverlayCanvas);
